import SeminarCheckInView from "../../features/learning/SeminarCheckInView";

const SeminarCheckInPage = () => <SeminarCheckInView />;

export default SeminarCheckInPage;
